export default {
  trainingDataHeadline: 'Trainingsdaten',
  outputDataHeadline: 'Original vs. Modell',
  inputDataHeadline: 'Modelleingabe',
  modelConfigHeadline: 'Modellparameter',
};
